// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"SearchForm_searchForm__3PZ7r","searchInput":"SearchForm_searchInput__3EG3m","searchBtn":"SearchForm_searchBtn__3SJea"};